import { useEffect } from "react";

// Tenant-selectable Link Hub fonts. DM Sans is the app font and is already loaded
// globally by src/index.css; every other family is fetched only when a page needs it.
export const AVAILABLE_FONTS = [
  { name: "DM Sans", value: "DM Sans", category: "sans-serif", weights: "400;500;700" },
  { name: "Poppins", value: "Poppins", category: "sans-serif", weights: "300;400;500;600;700" },
  { name: "Roboto", value: "Roboto", category: "sans-serif", weights: "300;400;500;700" },
  { name: "Open Sans", value: "Open Sans", category: "sans-serif", weights: "300;400;500;600;700" },
  { name: "Lato", value: "Lato", category: "sans-serif", weights: "300;400;700" },
  { name: "Montserrat", value: "Montserrat", category: "sans-serif", weights: "300;400;500;600;700" },
  { name: "Raleway", value: "Raleway", category: "sans-serif", weights: "300;400;500;600;700" },
  { name: "Nunito", value: "Nunito", category: "sans-serif", weights: "300;400;500;600;700" },
  { name: "Source Sans 3", value: "Source Sans 3", category: "sans-serif", weights: "300;400;500;600;700" },
  { name: "Oswald", value: "Oswald", category: "sans-serif", weights: "300;400;500;600;700" },
  { name: "Playfair Display", value: "Playfair Display", category: "serif", weights: "400;500;600;700" },
  { name: "Merriweather", value: "Merriweather", category: "serif", weights: "300;400;700" },
  { name: "Lora", value: "Lora", category: "serif", weights: "400;500;600;700" },
  { name: "Libre Baskerville", value: "Libre Baskerville", category: "serif", weights: "400;700" },
];

export const DEFAULT_FONT = "DM Sans";

const FONTS_BY_VALUE = new Map(AVAILABLE_FONTS.map((font) => [font.value, font]));

const fontHref = ({ value, weights }) =>
  `https://fonts.googleapis.com/css2?family=${value.replace(/ /g, "+")}:wght@${weights}&display=swap`;

const linkId = (value) => `tenant-font-${value.replace(/\s+/g, "-").toLowerCase()}`;

/**
 * Injects one Google Fonts stylesheet per requested family (deduplicated across the
 * document, kept after unmount so revisits hit the cache). Unknown families and the
 * globally loaded app font are ignored.
 */
export const useGoogleFonts = (families) => {
  const key = (families || []).filter(Boolean).join("|");

  useEffect(() => {
    if (!key) return;
    key.split("|").forEach((family) => {
      const font = FONTS_BY_VALUE.get(family);
      if (!font || font.value === DEFAULT_FONT) return;
      const id = linkId(font.value);
      if (document.getElementById(id)) return;
      const link = document.createElement("link");
      link.id = id;
      link.rel = "stylesheet";
      link.href = fontHref(font);
      document.head.appendChild(link);
    });
  }, [key]);
};
